export default {
  unavailableWarningTitle: 'Période de maintenance prévue',
  unavailableMessageTitle: 'Maintenance du système',
  unavailableWarning: 'Veuillez prendre note que nos systèmes ne seront pas disponibles le {{date}}, en raison d’une période de maintenance. Nous sommes désolés des inconvénients que cela peut vous causer.',
  unavailableMessage: 'Veuillez prendre note que nos systèmes ne sont présentement pas disponibles. Nous sommes désolés des inconvénients que cela peut vous causer.',
  unavailableEndDate: '</br>Nos systèmes seront à nouveau disponibles le {{date}}.',
  from: 'de',
  to: 'à',
  at: 'à',
};
